import { MessageModel } from "./MessageModel";

export class MessageThreadModel {
    messageThreadId: number;
    itemId?: number;
    offerId?: number;
    buyerId: number;
    sellerId: number;
    subject: string;
    createdTime: Date;
    buyerUnread: boolean = false;
    sellerUnread:boolean = false;
    lastUpdatedTime: Date;
    lastMessage?:MessageModel;
  
    constructor(data?: any) {
      this.messageThreadId = data?.messageThreadId ?? 0;
      this.itemId = data?.itemId;
      this.offerId = data?.offerId;
      this.buyerId = data?.buyerId ?? 0;
      this.sellerId = data?.sellerId ?? 0;
      this.subject = data?.subject ?? "";
      this.createdTime = data?.createdTime ? new Date(data.createdTime) : new Date();
      this.buyerUnread = data?.buyerUnread ?? false;
      this.sellerUnread = data?.sellerUnread ?? false;
      this.lastUpdatedTime = data?.lastUpdatedTime ? new Date(data.lastUpdatedTime) : new Date();
      this.lastMessage = data?.lastMessage ? new MessageModel(data.lastMessage) : undefined;
    }
  }